import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { i18n } from "@/plugins/i18n";
import axios from 'axios'
import VueAxios from 'vue-axios'

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

require("./assets/styles/style.css");

library.add(fab, faEnvelope);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router,
 
  i18n
}).$mount("#app");
